import { ref } from 'vue';

const deferredPrompt = ref<Event | null>(null);

if (import.meta.client) {
  if (window.deferredPrompt) {
    deferredPrompt.value = window.deferredPrompt;
  }

  window.addEventListener('pwa:deferredPrompt', (e: Event) => {
    window.deferredPrompt = (e as CustomEvent).detail;
    deferredPrompt.value = (e as CustomEvent).detail;
  });
}

export function useDeferredPrompt() {
  return deferredPrompt;
}
